import React from 'react';
import { Link } from 'react-router-dom';

import ShortcutsMenu from 'components/ShortcutsMenu';
import UserMenu from 'components/UserMenu';

import {
  SContainer,
  SCenterPart,
  SLeftPart,
  SStudioLogo,
  SRightContent,
  SRightPart,
} from './styled';

interface Props {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}

const BasicHeader = ({
  left = (
    <Link to="/">
      <SStudioLogo alt="Conversation Studio logo" />
    </Link>
  ),
  center,
  right = (
    <SRightContent>
      <ShortcutsMenu />
      <UserMenu />
    </SRightContent>
  ),
}: Props) => (
  <SContainer data-test="header">
    <SLeftPart data-test="left-part">{left}</SLeftPart>
    {center && <SCenterPart data-test="center-part">{center}</SCenterPart>}
    <SRightPart data-test="right-part">{right}</SRightPart>
  </SContainer>
);

export default BasicHeader;
